<template>
  <div>
    <ShowUsers />
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import ShowUsers from "@/views/pages/users/ShowUsers.vue";

export default {
  name: "Users",
  components: {
    ShowUsers,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("USERS.TITLE") },
    ]);
  },
};
</script>
